import {AppConfig} from "../AppConfig";
import {Messages} from "../messages/Messages";
import {roundToDigits} from "./langExtensions";

const messages = new Messages();

function unitOrDefault(unit: string | null) {
	return unit ? unit : 'DECIMETERS';
}

export class AreaUnitFormatter {
	static detailUnit(): string {
		return AppConfig.detailAreaUnit;
	}

	static containerUnit(): string {
		return AppConfig.containerAreaUnit;
	}

	static detailUnitLabel(): string {
		return AreaUnitFormatter.unitLabel(AreaUnitFormatter.detailUnit());
	}

	static containerUnitLabel(): string {
		return AreaUnitFormatter.unitLabel(AreaUnitFormatter.containerUnit())
	}

	static unitLabel(areaUnit: string | null): string {
		return messages.get(`AreaUnit.${unitOrDefault(areaUnit)}`)
	}

	static unitFixed(value: number | null, areaUnit: string | null): string {
		if (value == null || !Number.isFinite(value)) return '';
		if (unitOrDefault(areaUnit) == 'METERS')
			return roundToDigits(value, 5).toString();
		return roundToDigits(value, 5).toString();
	}

	static fromDecimeters(value: number | null, targetUnit: string | null): number | null {
		if (value == null || !Number.isFinite(value)) return value;

		if (targetUnit == 'METERS')
			return value / 100.0;
		return value;
	}

	static toDecimeters(value: number | null, valueUnit: string | null): number | null {
		if (value == null || !Number.isFinite(value)) return value;

		if (valueUnit == 'METERS')
			return value * 100;
		return value;
	}
}
